(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rk-social-proof"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__ppbLive) return;
  window.__ppbLive = true;

  var KEY = 'ppb_live_count';
  var OFF = 'ppb_live_off';

  function store(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function list(s) {
    return String(s || '').split(/[,\n]/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function pick(arr, last) {
    if (arr.length < 2) return 0;
    var i;
    do { i = Math.floor(Math.random() * arr.length); } while (i === last);
    return i;
  }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function build(d, data) {
    var a = el('a', 'ppb-live__link');
    a.href = d.product.url || '#';
    a.appendChild(el('span', 'ppb-live__dot'));
    if (data.thumb && d.product.img) {
      var im = el('img', 'ppb-live__img');
      im.src = d.product.img;
      im.alt = '';
      im.width = 46;
      im.height = 46;
      a.appendChild(im);
    }
    var t = el('span', 'ppb-live__txt');
    t.appendChild(el('strong', null, d.name));
    t.appendChild(document.createTextNode((d.city ? ' from ' + d.city : '') + ' ' + data.verb + ' '));
    t.appendChild(el('span', 'ppb-live__prod', d.product.title));
    if (data.showTime && d.time) t.appendChild(el('span', 'ppb-live__time', d.time));
    a.appendChild(t);
    return a;
  }

  function init(root) {
    root.setAttribute('data-ppb-ready', '1');
    var script = root.querySelector('script[data-ppb-data]');
    if (!script) return;
    var data;
    try { data = JSON.parse(script.textContent); } catch (e) { return; }

    data.names = list(data.names);
    data.cities = list(data.cities);
    data.times = list(data.times);
    data.verb = data.verb || 'purchased';
    if (!data.products || !data.products.length || !data.names.length) return;

    var editor = !!(window.Shopify && Shopify.designMode);
    if (!editor && store(OFF) === '1') return;

    var count = editor ? 0 : parseInt(store(KEY) || '0', 10) || 0;
    if (count >= data.max) return;

    var swap = data.mode === 'swap';
    var slot = root.querySelector('[data-ppb-slot]');
    if (swap && !slot) return;

    var inView = true;
    if (swap && 'IntersectionObserver' in window) {
      inView = false;
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }).observe(root);
    }

    var timer, node = null, hover = false, stopped = false, lastN = -1, lastP = -1;

    function show() {
      var ni = pick(data.names, lastN);
      var pi = pick(data.products, lastP);
      lastN = ni;
      lastP = pi;
      var d = {
        name: data.names[ni],
        city: data.showCity && data.cities.length ? data.cities[Math.floor(Math.random() * data.cities.length)] : '',
        time: data.times.length ? data.times[Math.floor(Math.random() * data.times.length)] : '',
        product: data.products[pi]
      };
      var content = build(d, data);

      if (swap) {
        slot.textContent = '';
        slot.appendChild(content);
        slot.onmouseenter = function () { hover = true; };
        slot.onmouseleave = function () { hover = false; };
        root.classList.add('is-live');
      } else {
        node = el('div', 'ppb-toast ppb-toast--' + (data.pos === 'right' ? 'right' : 'left'));
        node.setAttribute('role', 'status');
        node.style.setProperty('--ppb-tbg', data.bg);
        node.style.setProperty('--ppb-text', data.text);
        node.style.setProperty('--ppb-accent', data.accent);
        node.appendChild(content);
        var x = el('button', 'ppb-toast__x', '\u00d7');
        x.type = 'button';
        x.setAttribute('aria-label', 'Close');
        x.addEventListener('click', function () {
          stopped = true;
          clearTimeout(timer);
          hide();
          if (!editor) store(OFF, '1');
        });
        node.appendChild(x);
        node.onmouseenter = function () { hover = true; };
        node.onmouseleave = function () { hover = false; };
        document.body.appendChild(node);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { if (node) node.classList.add('is-in'); });
        });
      }
    }

    function hide() {
      hover = false;
      if (swap) {
        root.classList.remove('is-live');
      } else if (node) {
        var n = node;
        node = null;
        n.classList.remove('is-in');
        setTimeout(function () { n.remove(); }, 600);
      }
    }

    function schedule(sec) {
      clearTimeout(timer);
      timer = setTimeout(attempt, sec * 1000);
    }

    function attempt() {
      if (stopped) return;
      if (document.hidden || (swap && !inView)) { schedule(2); return; }
      show();
      timer = setTimeout(finish, data.visible * 1000);
    }

    function finish() {
      if (hover) { timer = setTimeout(finish, 1000); return; }
      hide();
      if (!editor) {
        count++;
        store(KEY, String(count));
        if (count >= data.max) { stopped = true; return; }
      }
      schedule(rnd(data.gapMin, Math.max(data.gapMin, data.gapMax)));
    }

    schedule(editor ? 2 : data.first);
  }

  function scan() {
    document.querySelectorAll('[data-ppb-live]:not([data-ppb-ready])').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
})();
  } catch(e) { console.error(e); }
})();

})();
